module.exports = "/_next/static/images/Trend01Visual@2x-b6f6634d1b9c3644b563a21dffcd5e69.png";